import React from 'react';
import HowItWorksStep1SVG from "../../components/Images/HowItWorksStep1SVG"
import HowItWorksStep2SVG from "../../components/Images/HowItWorksStep2SVG"
import HowItWorksStep3SVG from "../../components/Images/HowItWorksStep3SVG"
import HowItWorksStep4SVG from "../../components/Images/HowItWorksStep4SVG"
const english = {
  introduction_heading :'Become the writer of your dreams! ',
  create_novel_button_text: "Create A New Novel ",
  rewards_title: <>Rewards &amp; Benefits 🌟</>,
  rewards_para_text: <><strong>📢 Only the first 100 eligible books would be approved for the program 📢</strong></>,
  rewardsAndBenefitsArray: [
    {
      heading: 'New Story Signing Bonus 🖋️',
      subHeading: <>Get a one-time bonus of $1000 💸 💰 for every signed story (min 30,000 words) &amp; be eligible for additional performance bonuses</>,
      mobileSubHeading: 'Get a one-time bonus of $1000 💸 💰 for every signed story (min 30,000 words) & be eligible for additional performance bonuses',
      tableHeadings: ['Word Count (Minimum Words)', 'Reward 💸 💰'],
      table: [
        {
          wordCount: '30,000',
          reward: '$1000',
        },
      ],
      coinsBagImageSrc:"https://djhonz7dexnot.cloudfront.net/fd4cf8385986a486080798f5939a9e9a275c614c.png",
      note: <><strong>No plagiarised</strong> or inappropriate content</>,
      extraNotes: [],
    },
    {
      heading: 'Daily Update Bonus ⭐',
      subHeading: 'This reward will be based on the number of words you upload on Pocket Writer every month',
      mobileSubHeading:'This reward will be based on the number of words you upload on Pocket Writer every month',
      tableHeadings: ['Word Count (Monthly)', 'Reward 💸 💰'],
      table: [
        {
          wordCount: '25,000 - 34,999',
          reward: '$300',
        },
        {
          wordCount: '35,000 - 44,999',
          reward: '$600',
        },
        {
          wordCount: '45,000+',
          reward: '$1000',
        },
      ],
      note: <>The writers can miss a maximum of <strong>5 days in a month</strong></>,
      extraNotes: [],
    },
    {
      heading: 'Completion Bonus 🚀',
      subHeading: 'Receive rewards basis the corresponding word count! This will also entail a few performance based parameters.',
      mobileSubHeading: 'Receive rewards basis the corresponding word count! This will also entail a few performance based parameters.',
      tableHeadings: ['Word Count (Overall)', <>Minimum <br/>Reward 💸 💰</>, <>Performance <br/>Bonus💸 💰</>],
      table: [
        {
          wordCount: '250,000 - 349,999',
          reward: '$2500',
          bonus:'30%'
        },
        {
          wordCount: '350,000 - 449,999',
          reward: '$5250',
          bonus:'40%',
        },
        {
          wordCount: 'more than 450,000+',
          reward: '$9000',
          bonus:'50%'
        }
      ],
      note: <>The story should have <strong>a satisfying ending</strong></>,
      extraNotes: [],
    },
  ],
  deadline_content: <>   <span>Deadline To Enter Program </span><span role="img" aria-label="finish flag">🏁</span>   </>,
  deadline_subheading:<>The program would be open only for <strong>3 months of registration</strong></>,
  deadline_to_enter_button: "Become A Pocket Novel Writer ",
  deadline_date:<>1<sup>st</sup> Aug to 31<sup>st</sup> Oct</>,
  deadline_note:<>The novels shortlisted for the program would be declared by 31<sup>st</sup> Dec</>,
  howItWorksArray : [
    {
      step: '1',
      instruction:<>Apply for the Program ✍️</>,
        stepSVG:HowItWorksStep1SVG
    },
    {
      step: '2',
      instruction:<>Sign the contract &amp; receive the <strong>Joining Bonus</strong> 💸 💰</>,
        stepSVG:HowItWorksStep2SVG
  
    },
    {
      step: '3',
      instruction:<>Receive the <strong>Daily Update Bonus</strong> by updating your novel on a regular basis 💸 💰</>,
        stepSVG:HowItWorksStep3SVG
  
    },
    {
      step: '4',
      instruction:<>Once you complete 250,000 words with great reader reviews, your story becomes eligible to be made into an audiobook. Receive an additional <strong>Performance Bonus 💸 💰 from the Audiobook</strong></>,
        stepSVG:HowItWorksStep4SVG
  
    },
  ],
  pocketInTheNewsArray: [
    {
      id:1,
      date:"Jul 26, 2022",
      by:"The Economic Times",
      title:"Flipkart to partner with Pocket FM to enter audiobooks category",
      brief:<>According to research from Pocket FM, India currently ranks third in the world in the number of audiobook listeners, estimated at 25 million... <span>View More</span></>,
      imageSrc:"https://djhonz7dexnot.cloudfront.net/7d0215ca7093cabeaee6feaeae60223e8d8edfec.png",
      link:"https://economictimes.indiatimes.com/tech/startups/flipkart-to-partner-with-pocket-fm-to-enter-audiobooks-category/articleshow/93133736.cms"
    },
    {
      id:2,
      date:"Sep 07, 2022",
      by:"RM biz",
      title:"Pocket FM Romance Series megahit surpasses 50 million plays",
      brief:<>Pocket FM Romance Series megahit 'Kashi-Ek Prem Kahani' surpasses 50 million plays... <span>View More</span></>,
      imageSrc:"https://djhonz7dexnot.cloudfront.net/14b09768ddefe7fc0b4f8d30440f74ed0aaa1068.png",
      link:"https://www.radioandmusic.com/entertainment/editorial/news/220907-pocket-fm-romance-series-megahit-%E2%80%98kashi-ek",
    },
    {
      id:3,
      date:"Mar 03, 2022",
      by:"ENTRACKR",
      title:"Pocket FM raises $65 Mn from Goodwater Capital, Naver and Tanglin Venture",
      brief:<>Pocket FM, an audio over-the-top platform, has raised $65 million in its Series C round from Goodwater Capital, .... <span>View More</span></>,
      imageSrc:"https://djhonz7dexnot.cloudfront.net/6073c98c31fe60361154891b38f769f45ac29018.png",
      link:"https://entrackr.com/2022/03/pocket-fm-raises-65-mn-from-goodwater-capital-naver-and-tanglin-venture/",
    },
    {
      id:4,
      date:"Jun 07, 2022",
      by:"IndiaEducationDiary.com",
      title:"Pocket FM Augments Its Streaming Library",
      brief:<>New Delhi: Pocket FM, a personalized audio streaming service, today announced its partnership with Manjul Publishing House, .... <span>View More</span></>,
      imageSrc:"https://djhonz7dexnot.cloudfront.net/d2e03c106871349cbac62ad2c71489b202f4ec73.png",
      link:"https://indiaeducationdiary.in/pocket-fm-augments-its-streaming-library-with-bestsellers-from-manjul/"
    }
  ],
  step: "step",
  faq: <strong>Frequently Asked Questions </strong>,
  frequentlyAskedQuestionsArray : [
    {
      question: 'When will I receive payments for my rewards ?',
      answer:'Eligible Payments will be credited on or before the 2nd week of the subsequent month, given the contract is signed before 1st of the month. (eg: Payments for February will be made by the second week of March should the writer sign the contract by 1st of March).'
    },
    {
      question:'What is an inappropriate content?',
      answer:'Sex involving minors/forced sex/unnatural sex/pornographic content.'
    },
    {
      question:'How is the performance bonus calculated?',
      answer:`Be eligible to receive a performance bonus of 20% once the novel revenue exceeds the payments made (minimum revenue to be eligible - $1000) 
      Example - Revenue from the novel is $1500 and payment made to you is $1000(till date), the Performance Bonus will be 20% of $500($1500-$1000), i.e. $100`
    },
    {
      question:'How can I calculate my Completion Bonus?',
      answer:'The completion bonus is calculated basis the word count of the completed novel. The higher the word count, the higher the rewards!'
    },
    {
      question:'What is the performance bonus if my novel is converted in to an Audiobook?',
      answer:'The writer will be eligible for an additional performance bonus of 25% from the audiobook over and above the performance bonus and completion bonus received against the novel. This bonus would start getting credited once the production cost of the audiobook has been recovered i.e. when the revenue of the audiobook exceeds its production costs'
    }
  ],
  
  write_home_earn_stable_income_text :'Write at home & Earn a stable income.',
  write_home_earn_stable_income_subheading : "Start your journey to become a Pocket FM Writer and turn your passion into profession.",
  create_new_novel :"Create A New Novel ",
  footer_note:"NOTE: The above program is open only for writers based out of the US and citizens of the US."
 
}

export default english;